import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
type ContentTextProps = {
  content: string;
};
export default function ContentText(t0) {
  const $ = _c(2);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content) {
    t1 = <Typography variant="body" component="div" dangerouslySetInnerHTML={{
      __html: content
    }} />;
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}